// language=GraphQL
import { gql } from '@apollo/client'
import { ABSTRACT_SEARCH_ITEM } from '../fragments/interface.fragment'
import { allContentFragments } from '../fragments/allContent.fragment'

export const GET_FEATURED_BENEFIT = gql`
  query GetFeaturedBenefit {
    featuredBenefit {
      title
      subTitle
      benefit {
        ...AllContentItemNode
      }
    }
  }
  ${allContentFragments.fragments.node}
  ${ABSTRACT_SEARCH_ITEM}
`
